import type { ProfileTab } from '../../utils/navigationHelpers.ts'
import { QUERY_PARAM_TO_TAB } from '../../utils/navigationHelpers.ts'

export interface ProfileTabPrompt {
  label: string
  prompt: string
}

export const PROFILE_TAB_PROMPTS: Partial<
  Record<ProfileTab, { own: ProfileTabPrompt; other: ProfileTabPrompt }>
> = {
  resumen: {
    own: {
      label: 'Resumen',
      prompt: '¿Cómo puedo mejorar mi perfil en Edify?'
    },
    other: {
      label: 'Resumen',
      prompt: '¿Qué información puedo ver de los perfiles de los profesionales o empresas?'
    }
  },
  servicios: {
    own: {
      label: 'Productos/Servicios',
      prompt: '¿Cómo puedo crear y promocionar mis productos o servicios?'
    },
    other: {
      label: 'Productos/Servicios',
      prompt: '¿Me ayudás a explorar los productos y servicios de los profesionales o empresas?'
    }
  },
  oportunidades: {
    own: {
      label: 'Oportunidades',
      prompt: '¿Cómo puedo destacar mis proyectos, materiales y documentación pública?'
    },
    other: {
      label: 'Oportunidades',
      prompt: '¿Qué oportunidades públicas puedo ver en este perfil?'
    }
  },
  calificaciones: {
    own: {
      label: 'Calificaciones',
      prompt: '¿Cómo puedo conseguir más calificaciones?'
    },
    other: {
      label: 'Calificaciones',
      prompt: '¿Cómo calificar a los profesionales o empresas?'
    }
  },
  muro: {
    own: {
      label: 'Muro',
      prompt: '¿Cómo uso el muro de mi perfil para publicar novedades?'
    },
    other: {
      label: 'Muro',
      prompt: '¿Qué puedo ver en el muro de este perfil?'
    }
  },
  gestion: {
    own: {
      label: 'Gestión',
      prompt:
        '¿Cómo uso el panel de Gestión en mi perfil para administrar obra, materiales, vacantes laborales y comercio?'
    },
    other: {
      label: 'Perfil',
      prompt: '¿Me ayudás con la información de este perfil?'
    }
  }
}

const PROFILE_GENERIC = {
  own: { label: 'Perfil', prompt: '¿Cómo puedo aprovechar mejor mi perfil en Edify?' },
  other: { label: 'Perfil', prompt: '¿Qué información puedo ver de los perfiles de los profesionales o empresas?' }
}

export function getProfileContextualSuggestion(
  tabParam: string | null,
  isOwnProfile: boolean
): ProfileTabPrompt | null {
  if (!tabParam) return PROFILE_GENERIC[isOwnProfile ? 'own' : 'other']
  const tab = tabParam.trim().toLowerCase() as ProfileTab
  const tabConfig = PROFILE_TAB_PROMPTS[tab]
  if (!tabConfig) return PROFILE_GENERIC[isOwnProfile ? 'own' : 'other']
  const variant = isOwnProfile ? tabConfig.own : tabConfig.other
  return variant
}

export function getTabLabel(tabParam: string | null): string {
  if (!tabParam) return 'Perfil'
  const tab = tabParam.trim().toLowerCase() as ProfileTab
  return QUERY_PARAM_TO_TAB[tab] ?? 'Perfil'
}
